import React from 'react';
import { Route } from 'config/routes';
import { Link } from 'components/link';
import { DeveloperProjectMarketplace, IDeveloperProject } from 'utils/entities';
import { ListingCardsItem } from 'ds/components/ListingCard';
import CardInner from './CardInner';
import * as Styled from './styled';


interface ProjectCardProps {
  project: IDeveloperProject;
  headingTagH3?: boolean;
}

const Card: React.FC<ProjectCardProps> = ({ project, headingTagH3 }) => {
  const { marketplaceType, id } = project;
  const isCommercial = marketplaceType === DeveloperProjectMarketplace.Commercial;
  const linkRouteName = isCommercial
    ? Route.ProjectPageCommercial
    : Route.ProjectPage;

  return (
    <Styled.CardWrapper key={id}>
      <ListingCardsItem>
        <Link
          data-auto="listed-bulletin-clickable"
          routeName={linkRouteName}
          routeParams={{ id, tracking_event_source: 'developer_page' }}
          hideLinkParams
        >
          <Styled.ListingCardWrapper>
            <CardInner project={project} headingTagH3={headingTagH3}/>
          </Styled.ListingCardWrapper>
        </Link>
      </ListingCardsItem>
    </Styled.CardWrapper>
  );
};

export default React.memo(Card);
